/* eslint-disable */
import React from "react";
import Swal from "sweetalert2";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

const StyledIPTable = ({ ipList, onDeleteIP }) => {
  const { t } = useTranslation();
  const handleDelete = (ip) => {
    Swal.fire({
      title: t("OrderSettings.tab2.table.deleteConfirm.title"),
      text: t("OrderSettings.tab2.table.deleteConfirm.text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e74c3c",
      cancelButtonColor: "#bdc3c7",
      confirmButtonText: t("OrderSettings.tab2.table.deleteConfirm.title"),
      text: t("OrderSettings.tab2.table.deleteConfirm.text"),
    }).then((result) => {
      if (result.isConfirmed) {
        onDeleteIP(ip);
        Swal.fire(t("OrderSettings.tab2.table.deleteConfirm.successTitle"),
          t("OrderSettings.tab2.table.deleteConfirm.successText"), "success");
      }
    });
  };

  return (
    <div className="bg-gradient-to-br from-white to-purple-50 dark:from-[#181819] dark:to-[#1f1f1f] rounded-xl shadow-md w-full border border-[#fbf4ff] dark:!border-[#3c3a3d]">
      <div className="p-6 flex flex-col h-full">
        <h5 className="font-bold text-lg text-gray-800 dark:text-gray-200 m-0 flex items-center">
          {t("OrderSettings.tab2.table.title")}
        </h5>

        <div className="w-full overflow-visible bg-white dark:bg-[#181819] rounded-xl mt-4 shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-end">
              <thead>
                <tr className="bg-gradient-to-r from-purple-50 to-purple-100 dark:from-[#2a2a2a] dark:to-[#3a2e40]">
                  <th className="p-4 font-medium text-[#9e68ba]">
                    {t("OrderSettings.tab2.table.columns.ipAddress")}
                  </th>
                  <th className="p-4 font-medium text-[#9e68ba]">
                    {t("OrderSettings.tab2.table.columns.actions")}
                  </th>
                </tr>
              </thead>

              <tbody>
                {ipList && ipList.length > 0 ? (
                  ipList.map((ip, index) => (
                    <tr
                      key={index}
                      className={`border-b border-gray-200 dark:!border-[#3c3a3d] hover:bg-[#fcf6ff] dark:hover:bg-[#2f2436] transition-colors ${index % 2 === 0
                          ? "bg-white dark:!bg-[#181819]"
                          : "bg-gray-50 dark:!bg-[#222222]"
                        }`}
                    >
                      <td className="p-4 font-medium text-gray-800 dark:text-gray-200">{ip}</td>
                      <td className="p-4">
                        <button
                          onClick={() => handleDelete(ip)}
                          className="p-2 rounded-full hover:bg-red-100 dark:hover:bg-red-900/40 transition-colors text-red-500"
                        >
                          <Trash2 size={18} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={2}
                      className="p-8 text-center text-gray-500 dark:text-gray-400 dark:!bg-[#181819] "
                    >
                      {t("OrderSettings.tab2.table.empty")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StyledIPTable;
